import styled from 'styled-components';
import { Button } from './Button';
import { LinkButton } from './LinkButton/LinkButton';

/**
 * These are required so we can reference these components inside other styled components.
 * This shouldn't be required, but we have add styling to some components using css attr
 * instead of creating it as a styled comp instance
 */
export const StyledButton = styled(Button)``;

export const StyledLinkButton = styled(LinkButton)`
  width: auto;
`;
